import { BaseRESTService } from '../../common/services/BaseRESTService';

export class AuthorizationService extends BaseRESTService {
  async login(username: string, password: string): Promise<string> {
    const { data } = await this.post('/api/v2/auth', { username, password }, { omitAuthHeader: true });
    return data.apiKey;
  }
}
